module.exports = ".documents-container {\n  min-height: 20vh; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/camera-documents-attacher/camera-documents-attacher.component.scss
// module id = ./src/app/shared/components/camera-documents-attacher/camera-documents-attacher.component.scss
// module chunks = main